import { useContext, useMemo } from "react";
import { ProdutosBodyContext } from "../contexts/ProdutosBodyContext";
import TabGuias from "../children/tabsprodutos/TabGuias";
import TabGeral from "../children/tabsprodutos/TabGeral";
import {
  findEmpresasV2,
  updateEmpresasV2,
} from "../../../../repositories/qerpapi/erp/prouser/v2/EmpresasRepository";
import { notify } from "../../../../utils/notify";
import Swal from "sweetalert2";

const useProdutosBodyController = (setLoading, setOpen) => {
  const {
    // tab geral
    barcodeType,
    useUniqueStockPrice,
    setUseUniqueStockPrice,
    useStockLocation,
    setUseStockLocation,
    useWholesalePrice,
    setUseWholesalePrice,
    useBalance,
    setUseBalance,
    usePriceTable,
    setUsePriceTable,
    allowsFixedPrice,
    setAllowsFixedPrice,
    updateRealCost,
    setUpdateRealCost,

    // tab formação custos
    shipment,
    setShipment,
    insurance,
    setInsurance,
    discount,
    setDiscount,
    otherExpenses,
    setOtherExpenses,
    icmsSt,
    setIcmsSt,
    ipi,
    setIpi,
    pis,
    setPis,
    cofins,
    setCofins,

    // tab guias
    suppliers,
    setSuppliers,
    datasheet,
    setDatasheet,
    relatedAndSimilar,
    setRelatedAndSimilar,
    integration,
    setIntegration,

    queryParams,
    setQueryParams,
  } = useContext(ProdutosBodyContext);

  const switchesGeneral = useMemo(
    () => [
      {
        label: "Utiliza Tabela de Preço?",
        value: usePriceTable,
        setValue: setUsePriceTable,
        disabled: useUniqueStockPrice || useWholesalePrice,
      },
      {
        label: "Permite Preço Fixo?",
        value: allowsFixedPrice,
        setValue: setAllowsFixedPrice,
        disabled: !usePriceTable,
      },
      {
        label: "Utiliza Preço de Estoque Único?",
        value: useUniqueStockPrice,
        setValue: setUseUniqueStockPrice,
        disabled: usePriceTable || useWholesalePrice,
      },
      {
        label: "Utiliza Localização de Estoque?",
        value: useStockLocation,
        setValue: setUseStockLocation,
      },
      {
        label: "Utiliza Preço de Atacado e Varejo?",
        value: useWholesalePrice,
        setValue: setUseWholesalePrice,
        disabled: usePriceTable || useUniqueStockPrice,
      },
      {
        label: "Atualiza Custo Real á Partir do Médio?",
        value: updateRealCost,
        setValue: setUpdateRealCost,
      },
      {
        label: "Utiliza Balança?",
        value: useBalance,
        setValue: setUseBalance,
      },
    ],
    [
      allowsFixedPrice,
      setAllowsFixedPrice,
      setUpdateRealCost,
      setUseBalance,
      setUsePriceTable,
      setUseStockLocation,
      setUseUniqueStockPrice,
      setUseWholesalePrice,
      updateRealCost,
      useBalance,
      usePriceTable,
      useStockLocation,
      useUniqueStockPrice,
      useWholesalePrice,
    ]
  );

  const switchesGuides = [
    {
      label: "Fornecedores",
      value: suppliers,
      setValue: setSuppliers,
    },
    {
      label: "Ficha Técnica/Comercial",
      value: datasheet,
      setValue: setDatasheet,
    },
    {
      label: "Relacionados e Similares",
      value: relatedAndSimilar,
      setValue: setRelatedAndSimilar,
    },
    {
      label: "Integração",
      value: integration,
      setValue: setIntegration,
    },
  ];

  const optionsBarcode = [
    {
      value: "EAN13",
      label: "EAN13",
    },
    {
      value: "G",
      label: "Genérico",
    },
  ];

  const optionsZeros = [
    {
      value: "2",
      label: "2 (ex: 0,00)",
    },
    {
      value: "3",
      label: "3 (ex: 0,000)",
    },
    {
      value: "4",
      label: "4 (ex: 0,0000)",
    },
    {
      value: "5",
      label: "5 (ex: 0,00000)",
    },
  ];

  const optionsBuildCosts = [
    {
      value: "A",
      label: "Acrescentar",
    },
    {
      value: "S",
      label: "Subtrair",
    },
    {
      value: "I",
      label: "Ignorar",
    },
  ];

  const inputRadioItems = [
    { label: "Frete", value: shipment, setValue: setShipment },
    {
      label: "Seguro",
      value: insurance,
      setValue: setInsurance,
    },
    {
      label: "Desconto",
      value: discount,
      setValue: setDiscount,
    },
    {
      label: "Outras despesas",
      value: otherExpenses,
      setValue: setOtherExpenses,
    },
    {
      label: "ICMS ST",
      value: icmsSt,
      setValue: setIcmsSt,
    },
    {
      label: "IPI",
      value: ipi,
      setValue: setIpi,
    },
    {
      label: "PIS",
      value: pis,
      setValue: setPis,
    },
    {
      label: "COFINS",
      value: cofins,
      setValue: setCofins,
    },
  ];

  const tabTitles = [
    { label: "Geral" },
    // { label: "Formação de Custos", disabled: true },
    // { label: "Local de Estoque", disabled: true },
    { label: "Guias" },
  ];

  const tabContents = [
    <TabGeral key="tab-geral-produtos" />,
    // <></>,
    // <></>,
    <TabGuias key="tab-guias-produtos" />,
  ];

  const handleSaveProductParams = async () => {
    setLoading(true);
    const productParamsBody = {
      // Aba geral:
      tipocodigobarras: barcodeType?.value ?? null,
      paramutilizatabelaprecos: usePriceTable ? "SIM" : "NAO",
      permiteprecofixo: allowsFixedPrice ? "SIM" : "NAO",
      paramprecoestoqueunico: useUniqueStockPrice ? "SIM" : "NAO",
      paramutilizavarejoatacado: useWholesalePrice ? "SIM" : "NAO",
      atualizacustomedio: updateRealCost ? "SIM" : "NAO",
      paramutilizacodigobalanca: useBalance ? "SIM" : "NAO",

      // Aba guias:
      guia_produtos_fornecedores: suppliers ? 1 : 0,
      guia_produtos_fichatecnica: datasheet ? 1 : 0,
      guia_produtos_relacionados: relatedAndSimilar ? 1 : 0,
      guia_produtos_integracao: integration ? 1 : 0,
    };

    try {
      let companyIds = [],
        successful = 0,
        getAllCompanyIds = await findEmpresasV2(queryParams.empresa_cnpj);

      if (getAllCompanyIds.success)
        companyIds = getAllCompanyIds.data.map((e) => e.id);
      else
        throw new Error(
          "Ocorreu um erro ao buscar as empresas no sistema. Tente novamente."
        );

      for (const id of companyIds) {
        const updateProductParams = await updateEmpresasV2({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: id,
          body: productParamsBody,
        });

        if (updateProductParams.success) successful++;
      }

      if (successful === companyIds.length) {
        Object.keys(productParamsBody).forEach((key) => {
          if (productParamsBody[key] || productParamsBody[key] === 0) {
            sessionStorage.setItem(key, productParamsBody[key].toString());
            productParamsBody[key] = productParamsBody[key].toString();
          } else {
            sessionStorage.setItem(key, "");
            productParamsBody[key] = "";
          }
        });

        setQueryParams((current) => ({ ...current, ...productParamsBody }));

        notify("Parâmetros atualizados com sucesso!", true, "success");

        Swal.fire({
          icon: "warning",
          text: "Para os parâmetros da guia 'Geral' surtirem efeito, você precisa fazer o login novamente.",
          showConfirmButton: true,
          confirmButtonText: "Entendido",
        }).then((res) => {
          if (res.isConfirmed) setOpen(false);
        });
      } else
        throw new Error(
          "Não conseguimos atualizar os parâmetros de todas as empresas. Tente novamente."
        );
    } catch (e) {
      notify(e, false, "error");
    } finally {
      setLoading(false);
    }
  };

  return {
    switchesGuides,
    switchesGeneral,
    optionsBarcode,
    optionsZeros,
    tabTitles,
    tabContents,
    optionsBuildCosts,
    inputRadioItems,
    handleSaveProductParams,
  };
};

export default useProdutosBodyController;
